import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { Component, OnInit, signal } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { firstValueFrom } from 'rxjs';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { EmpresaStateService } from '../../services/empresa-state.service';

interface ParceiroSugestao {
    codparc: string | number;
    nomeparc: string;
    docparc: string;
    tipoBusca: 'CLIENTE';
}

// @ts-ignore
@Component({
    selector: 'app-gpl-relatorio-comissionamento',
    standalone: true,
    imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
    templateUrl: './gpl-relatorio-comissionamento.component.html',
    styleUrl: './gpl-relatorio-comissionamento.component.css'
})
export class GplRelatorioComissionamentoComponent implements OnInit {
    carregando = signal(false);

    filtros = {
        dataInicial: this.formatarDataInput(this.diasAntes(new Date(), 30)),
        dataFinal: this.formatarDataInput(new Date()),
        codParc: null as number | null
    };

    // Controle do Modal
    modalParceiroAberta = false;
    filtroBuscaModal = '';
    filtroParceiroTexto = '';
    statusBuscaParceiro = 'Digite ao menos 2 caracteres para pesquisar...';
    listaParceirosSugeridos = signal<ParceiroSugestao[]>([]);

    private buscaParceiroTimer: ReturnType<typeof setTimeout> | null = null;
    dadosResultado: any[] = [];
    buscaMensagem = 'Preencha o período e aplique os filtros para buscar.';

    constructor(
        private readonly sankhyaGateway: SankhyaGatewayService,
        readonly empresaState: EmpresaStateService
    ) {}

    ngOnInit(): void {
        this.empresaState.carregar();
    }

    abrirModalParceiro(): void {
        this.filtroBuscaModal = '';
        this.statusBuscaParceiro = 'Digite ao menos 2 caracteres para pesquisar...';
        this.listaParceirosSugeridos.set([]);
        this.modalParceiroAberta = true;
    }

    fecharModalParceiro(): void {
        this.modalParceiroAberta = false;
    }

    agendarBuscaParceirosModal(): void {
        if (this.buscaParceiroTimer) {
            clearTimeout(this.buscaParceiroTimer);
        }

        if (this.filtroBuscaModal.trim().length < 2) {
            this.listaParceirosSugeridos.set([]);
            this.statusBuscaParceiro = 'Digite ao menos 2 caracteres para pesquisar...';
            return;
        }

        this.buscaParceiroTimer = setTimeout(() => {
            this.statusBuscaParceiro = 'Buscando parceiros...';
            this.sankhyaGateway.buscarClientesImpressao({ CLIENTE: this.filtroBuscaModal.trim() }).subscribe({
                next: (value: any) => {
                    const body = value?.responseBody || value;
                    const lista = this.normalizarClientes(body?.lista || body?.clientes || []);
                    this.listaParceirosSugeridos.set(lista);
                    this.statusBuscaParceiro = lista.length ? '' : 'Nenhum parceiro comissionado localizado.';
                },
                error: () => this.statusBuscaParceiro = 'Erro na comunicação ao buscar parceiros.'
            });
        }, 300);
    }

    selecionarParceiroModal(parceiro: ParceiroSugestao): void {
        this.filtros.codParc = Number(parceiro.codparc);
        this.filtroParceiroTexto = parceiro.nomeparc;
        this.fecharModalParceiro();
    }

    limparParceiroSelecionado(): void {
        this.filtros.codParc = null;
        this.filtroParceiroTexto = '';
    }

    private normalizarClientes(lista: any[]): ParceiroSugestao[] {
        if (!Array.isArray(lista)) return [];
        const vistos = new Set<string>();
        const resultado: ParceiroSugestao[] = [];

        for (const item of lista) {
            const codparc = item.codparc || item.CODPARC;
            const nomeparc = item.nomeparc || item.NOMEPARC || item.nomeParc;
            const docparc = item.docparc || item.DOCPARC || item.CNPJ || item.CGC_CPF || '';

            if (!codparc || !nomeparc) continue;
            const chave = docparc.replace(/\D/g, '') || `COD:${codparc}`;

            if (!vistos.has(chave)) {
                vistos.add(chave);
                resultado.push({ codparc, nomeparc, docparc, tipoBusca: 'CLIENTE' });
            }
        }
        return resultado;
    }

    async buscarRelatorioComissionamento(): Promise<void> {
        if (!this.filtros.dataInicial || !this.filtros.dataFinal) {
            this.buscaMensagem = 'As datas Inicial e Final são obrigatórias para realizar a consulta.';
            return;
        }

        this.carregando.set(true);
        this.dadosResultado = [];
        this.buscaMensagem = 'Buscando informações no servidor...';

        try {
            const response: any = await firstValueFrom(
                this.sankhyaGateway.consultarComissionamento({
                    dataIni: this.filtros.dataInicial,
                    dataFim: this.filtros.dataFinal,
                    codParc: this.filtros.codParc
                })
            );

            const resBody = response?.responseBody ?? response;

            if (resBody.sucesso && resBody.dadosRelatorio) {
                this.dadosResultado = Array.isArray(resBody.dadosRelatorio)
                    ? resBody.dadosRelatorio
                    : [resBody.dadosRelatorio];

                this.buscaMensagem = this.dadosResultado.length === 0 ? 'Nenhum registro encontrado para os filtros aplicados.' : '';
            } else {
                this.buscaMensagem = resBody.erro || 'Erro ao carregar dados do relatório.';
            }
        } catch (e) {
            this.buscaMensagem = 'Erro de comunicação com o servidor.';
        } finally {
            this.carregando.set(false);
        }
    }

    limparFiltrosTela(): void {
        this.limparParceiroSelecionado();
        this.dadosResultado = [];
        this.buscaMensagem = 'Preencha o período e aplique os filtros para buscar.';
    }

    imprimirRelatorio(): void { window.print(); }
    private diasAntes(data: Date, dias: number): Date { const d = new Date(data); d.setDate(data.getDate() - dias); return d; }
    private formatarDataInput(data: Date): string { return data.toISOString().split('T')[0]; }
    formatarPercentual(valor: number): string { return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor || 0) + '%'; }
    formatarMoeda(valor: number): string { return (valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
    aoMudarDataInicial(n: string): void { if (!n) return; const d = new Date(n + 'T00:00:00'); d.setDate(d.getDate() + 30); this.filtros.dataFinal = d.toISOString().split('T')[0]; }
}